import GRRHDashboard from "@features/rh/components/GRRHDashboard";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Activity } from "lucide-react";

export const Route = createFileRoute("/_app/rh/")({
  staticData: {
    title: "RH",
    icon: Activity,
    tab_icon: Activity,
    permission: PERMISSIONS.RH.EMPLOYES.VIEW,
    section: "App",
    order: 10,
    description: "Tableau de bord RH",
    module: "rh",
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: GRRHDashboard,
});
